import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { RouterModule, Routes } from "@angular/router";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatTabsModule } from "@angular/material/tabs";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { TranslocoModule } from "@jsverse/transloco";

import { LorenUserAccessComponent } from "./loren-user-access/loren-user-access.component";
import { LorenHierarchySelectorModule } from "../../shared/modules/loren-hierarchy-selector/loren-hierarchy-selector.module";
import { LorenUserFilterPipe } from "./pipes/loren-user-filter.pipe";
import { LorenImageModule } from "../../shared/pipes/loren-image/loren-image.module";
import { LorenPageContentComponent } from "../../shared/modules/loren-page-content/loren-page-content.component";

const routes: Routes = [
  {
    path: "",
    component: LorenUserAccessComponent,
  },
];

@NgModule({
  declarations: [LorenUserAccessComponent, LorenUserFilterPipe],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule.forChild(routes),
    MatCardModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatProgressSpinner,
    MatTabsModule,
    TranslocoModule,
    LorenHierarchySelectorModule,
    LorenImageModule,
    LorenPageContentComponent
],
})
export class LorenUserAccessModule {}
